import { Request } from '../../Servidor/Request';

export class LocalTypeRequest {
    private sgeptipolocal: number;
    private nome: string;

    constructor(sgeptipolocal: number, nome: string) {
        this.sgeptipolocal = sgeptipolocal;
        this.nome = nome;
    }


    /**
     * Getter sgeptipolocal
     * @return {number}
     */
    public getSgepTipoLocal(): number {
        return this.sgeptipolocal;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class LocalTypeStructRequest {
    private sgeptipolocal: number;

    constructor(sgeptipolocal: number) {
        this.sgeptipolocal = sgeptipolocal;
    }


    /**
     * Getter sgeptipolocal
     * @return {number}
     */
    public getSgepTipoLocal(): number {
        return this.sgeptipolocal;
    }

}

export class LocalTypeStructResponse {
    private sgeptipolocal: number;
    private nome: string;

    constructor(sgeptipolocal: number, nome: string) {
        this.sgeptipolocal = sgeptipolocal;
        this.nome = nome;
    }


    /**
     * Getter sgeptipolocal
     * @return {number}
     */
    public getSgepTipoLocal(): number {
        return this.sgeptipolocal;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class LocalTypeInteractor {
    public fetchSave(request: LocalTypeRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/tipo-local/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: LocalTypeStructRequest): PromiseLike<LocalTypeStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/tipo-local/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}